export default "__VITE_ASSET__BFQgzDQc__"